import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import useCorporateLeadCreate from '../../hooks/useCorporateLeadCreate';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import Button from '../BaseUI/Button';
import TextField from '../FormFields/TextField';
import styles from './styles.module.scss';

const schema = () =>
  Yup.object().shape({
    email: Yup.string().email().required('Email is Required'),
  });

const FooterSection = () => {
  const { mutate: createCorporateLead } = useCorporateLeadCreate(true);
  const handleSubmit = ({ email }) => {
    createCorporateLead({ corporate_lead: { email } });
  };
  const hydrated = useServerSideRendering();

  return (
    <div className={styles.footerContainer} id="footerContainer">
      <div className="container">
        <div className={styles.footerWrapper}>
          <div className={styles.footerHeader}>Get in Contact</div>
          <div className={styles.footerSubheader}>
            Find out how a Group Subscription can impact your business.
          </div>
          {hydrated && (
            <Formik validationSchema={schema} initialValues={{ email: '' }} onSubmit={handleSubmit}>
              {(formik) => (
                <Form onSubmit={formik.handleSubmit}>
                  <div className={styles.footerFormContainer}>
                    <TextField name="email" placeholder="Enter your email" />
                    <Button variant="primary" type="submit">
                      CONTACT US
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
          <div className={styles.emailContactWrapper}>
            <div className={styles.emailContact}>
              If you are interested in content distribution or partnerships, please contact{' '}
              <a href="mailto:corporate@theinformation.com">corporate@theinformation.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
